import { useState } from 'react';
import { CONTACT_ITEMS } from '../../constants';
import { Reveal, TextReveal } from '../../components/Reveal';

export const ContactSection = () => {
  const [copyState, setCopyState] = useState('idle');
  const email = CONTACT_ITEMS.find((item) => item.label === 'Email');
  const socials = CONTACT_ITEMS.filter((item) => item.label !== 'Email');

  const copyEmail = async () => {
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(email.value);
      setCopyState('copied');
    } catch {
      setCopyState('failed');
    }
  };

  return (
    <section id="contact" className="pf-section pf-contact-section">
      <div className="pf-container">
        <Reveal className="pf-contact-heading" distance={8}>
          <span className="pf-section-index">04 / Contact</span>
          <span className="pf-contact-availability"><span aria-hidden="true" />Open to internships &amp; collaborations</span>
        </Reveal>

        <div className="pf-contact-layout">
          <div className="pf-contact-copy">
            <TextReveal delay={0.08}>Have an idea?<br /><span className="pf-contact-accent">Let's build it.</span></TextReveal>
            <Reveal as="p" delay={0.16}>Have a project, a question, or a team I could join? Send me a note. I'd like to hear what you're working on.</Reveal>
            <Reveal as="a" distance={0} delay={0.24} className="pf-contact-primary" href={email.href} aria-label="Email Jam">
              <span>Email Jam</span><span aria-hidden="true">↗</span>
            </Reveal>
          </div>

          <Reveal className="pf-contact-directory" delay={0.16}>
            <div className="pf-contact-direct-top"><span>Direct line</span><span aria-hidden="true">✳</span></div>
            <a className="pf-contact-address" href={email.href}>{email.value}</a>
            <button className="pf-contact-copy-button" type="button" onClick={copyEmail} aria-label="Copy email address">
              <span>{copyState === 'copied' ? 'Copied to clipboard' : 'Copy email address'}</span><span aria-hidden="true">{copyState === 'copied' ? '✓' : '↗'}</span>
            </button>
            {copyState !== 'idle' && <p className="pf-contact-copy-status" role="status">{copyState === 'copied' ? 'Email copied' : 'Copy unavailable. Use the email link above.'}</p>}

            <div className="pf-contact-social-heading">Find me online</div>
            <div className="pf-contact-socials">
              {socials.map((item, index) => (
                <Reveal as="a" distance={0} delay={0.2 + index * 0.08} key={item.label} href={item.href} target="_blank" rel="noopener noreferrer">
                  <span className="pf-contact-social-icon" aria-hidden="true">{item.icon}</span>
                  <span>{item.label}</span>
                  <span aria-hidden="true">↗</span>
                </Reveal>
              ))}
            </div>
            <p className="pf-contact-location">Based in Cebu, Philippines <span aria-hidden="true">/</span> Working across web, mobile, and AI</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
